<template>
	<div class="animate__animated animate__fadeIn">
		<top-bar :shadow="true">
			<div class="top-box">
				<img :src="logoImg" class="logo">
				<div class="menus-box" :style="fontColor">
					<div class="menus" v-for="(m,mi) in menus" :style="active == m.path ? {fontWeight:600} : ''" :key="mi" @mouseover="changeOver(m)" :class="m.hover ? 'hover-bg' : '' " @mouseleave="mouseLeave(m)" @click="changePath(m)">
						{{m.name}}
						<div class="dt-line" v-if="active == m.path" :style="dtBg"></div>
						<div class="se-me hover-bg" v-if="m.hover" >
							<div class="child" :style="fontColor" v-for="(c,ci) in m.child" :key="ci" @click.stop="changePath(c)">
								{{c.name}}
							</div> 
						</div>
					</div>
				</div>
			</div>
		</top-bar>
		<div class="header-tag">
			<span>解决方案 - 项目案例</span>
			<span style="color: #666;">--固碳混凝土国内首次应用</span>
		</div>
		<div class="body-box">
			<div class="left-box">
<!-- 				<div class="tag-title">其他案例</div> -->
				<div class="dot"></div>
			</div>
			<div class="right-box">
				<div class="ri-title">固碳混凝土国内首次应用 CCUS技术助推全国首个施工期内实现碳中和项目落地</div>
				<div class="content">
					为实现建筑项目在施工期内达到碳中和，利用CCUS技术生产的固碳混凝土建材近期在我国香港地区进行使用，这也是首个在中国应用二氧化碳矿化混凝土建材的建筑项目。该款拥有固碳属性的混凝土将帮助香港有机资源回收中心二期工程（O·PARK2）项目在施工阶段大幅降低碳足迹，助力其成为全国首个在施工期内实现碳中和的绿色工程。
				</div>
				<img src="../static/project/zz1.png" >
				<div class="content">
					建筑行业长期是我国的“碳排放大户”。据中国建筑节能协会发布的《2020年中国建筑能耗研究报告》数据显示，2018年全国建筑全过程碳排放总量为49.3亿吨，占全国碳排放总量的51.3%。其中，建材生产、建筑施工与建筑运营各占建筑总碳排的55.2%、2.0%、42.8%。毫无疑问，建筑行业是实现碳减排和碳中和目标的关键。
				</div>
				<div class="content">
					<span style="text-align: center;display:block;font-weight: 600;">固碳混凝土建材国内首次应用</span>
				</div>
				<div class="content">
					据介绍，香港有机资源回收中心二期工程（O·PARK2） 项目是由香港环保署主导、中国建筑国际集团承建的香港目前规模最大的厨余回收中心，于2019年启动，预计于2023年完工并投入使用。该项目承诺将成为全国首个在施工期内实现碳中和的绿色工程。
				</div>
				<img src="../static/project/zz2.png" >
				<div class="content">
					在O·PARK2项目施工阶段，中国建筑国际集团旗下中国建筑工程（香港)与清洁捕获达成合作，利用CCUS技术生产固碳混凝土建材，该款混凝土产品在通过了相关质量检测后，目前已应用于该项目的墙体结构建造环节。经过测算，每使用1立方米的固碳混凝土产品与香港地区传统产品相比较可减少61公斤的二氧化碳排放，相当于1棵树三年的二氧化碳吸收量。此次清洁捕获固碳建材产品的应用，将帮助该项目大幅降低施工阶段的碳排放。
				</div>
				<img src="../static/project/zz3.png" >
				<img src="../static/project/zz4.png" >
				<div class="content">
					<span style="text-align: center;display:block;font-weight: 600;">CCUS技术将二氧化碳封存在混凝土里</span>
				</div>
				<img src="../static/project/zz5.png" >
				<div class="content">
					CCUS（碳捕集、利用与封存）技术是实现碳中和的关键减排路径之一，其中二氧化碳矿化混凝土技术被广泛认为是在发展中国家最有潜力的利用技术路线。其技术原理则是通过将工业排放的二氧化碳与早期水化成型后的混凝土中胶凝成分和其他碱性钙、镁组分之间形成矿化反应，在混凝土内部孔隙和界面结构处形成碳酸盐产物，并通过填充效应、界面过渡区消除效应和产物层效应等实现混凝土的强度和耐久性改善，同时达到碳固定的效果。
				</div>
				<img src="../static/project/zz6.png" >
				<div class="content">
					据了解，为O·PARK2项目提供固碳混凝土建材的清洁捕获公司，是一家专注于CCUS技术研发与产业化的科技企业，目前已开发的二氧化碳捕集-矿化混凝土建材技术，可以实现95%以上的二氧化碳被高效利用并封存于混凝土建材中，减少30%以上原材料中的水泥用量。相较传统工艺在生产环节可减少80%左右的碳排放，部分清洁捕获的工厂中甚至可达到混凝土产品的负碳出厂，同时由于工艺技术的创新，产品的养护时间相较传统工艺缩减了一半，大幅降低了产品的人工成本、能耗需求。
				</div>
				<img src="../static/project/zz7.png" >
				<img src="../static/project/zz8.png" >
				<div class="content">
					混凝土是目前世界上用途最广、用量最大的建筑材料，混凝土生产和使用产生的碳排放约占全球碳排放的7%左右。随着未来CCUS技术的进一步研发与推广应用，各种来源排放的二氧化碳可永久封存在建筑物和道路中，这意味着未来世界各地的道路、建筑、停车场等都有可能作为潜在碳汇加以利用。
				</div>
			</div>
		</div>
		<div style="width: 100%;margin-top: 251px;">
			<footer-bar></footer-bar>
		</div>
	</div>
</template>

<script>
	import topBar from '@/components/header-bar.vue'
	import utils from '@/utils/common.js'
	import footerBar from '@/components/footer-bar.vue'
	export default{
		components:{
			topBar,
			footerBar
		},
		data(){
			return{
				name:'solution',
				menus:utils.menus,
				active:'solution',
				swiperIndex:1,
			}
		},
		computed:{
			logoImg(){
				// console.log(this.swiperIndex,'lll')
				if(this.swiperIndex == 0){
					return require('../static/qlogo.png')
				}
				else if(this.swiperIndex == 1){
					return require('../static/qlogo.png')
				}
				else if(this.swiperIndex == 2){
					return require('../static/qlogo.png')
				}
				else if(this.swiperIndex == 3){
					return require('../static/home/logo2.png')
				}
				else if(this.swiperIndex == 4){
					return require('../static/home/logo2.png')
				}
				else if(this.swiperIndex == 5){
					return require('../static/wlogo.png')
				}
				else if(this.swiperIndex == 6){
					return require('../static/home/logo2.png')
				}
				
			},
			fontColor(){
				if(this.swiperIndex == 0){
					return {
						color:'#fff'
					}
				}
				else if(this.swiperIndex == 1){
					return {
						color:'#333'
					}
				}
				else if(this.swiperIndex == 2){
					return {
						color:'#fff'
					}
				}
				else if(this.swiperIndex == 3){
					return {
						color:'#333'
					}
				}
				else if(this.swiperIndex == 4){
					return {
						color:'#333'
					}
				}
				else if(this.swiperIndex == 5){
					return {
						color:'#fff'
					}
				}
				else if(this.swiperIndex == 6){
					return {
						color:'#333'
					}
				}
			},
			dtBg(){
				if(this.swiperIndex == 0){
					return {
						background:'#fff'
					}
				}
				else if(this.swiperIndex == 1){
					return {
						background:'#333'
					}
				}
				else if(this.swiperIndex == 2){
					return {
						background:'#fff'
					}
				}
				else if(this.swiperIndex == 3){
					return {
						background:'#333'
					}
				}
				else if(this.swiperIndex == 4){
					return {
						background:'#333'
					}
				}
				else if(this.swiperIndex == 5){
					return {
						background:'#fff'
					}
				}
				else if(this.swiperIndex == 6){
					return {
						background:'#333'
					}
				}
			}
		},
		methods:{
			changeOver(m){
				// console.log(m)
				if(m.path == 'solution'){
					m.hover = true
					this.active = m.path
				}
			},
			mouseLeave(m){
				this.menus.forEach(item=>item.hover = false)
				this.active = this.name
			},
			changePath(item){
				if( item.path != 'solution'){
					this.$router.push({
						name:item.path
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.wrap {
	    width: 100%;
	    height: 100vh;
	    overflow: hidden;
	    // background: #eeeeee;
		margin: 0;
		padding: 0;
		
	}
		.active-h{
			font-weight: 600;
		}
	.top-box{
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		// background: #007AFF;
		.logo{
			width: 42px;
			height: 47px;
			margin-left: 11.25rem;
		}
		.menus-box{
			height: 100%;
			display: flex;
			align-items: center;
			margin-left: 510px;
			position: relative;
		}
		.menus{
			height: 100%;
			width: 114px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			// margin-right: 60px;
			font-size: 14px;
			font-weight: 400;
			
			cursor: pointer;
			box-sizing: border-box;
			position: relative;
			.dt-line{
				width: 20px;
				height: 4px;
				// background: #FFFFFF;
				position: absolute;
				bottom: 16px;
			}
			.se-me{
				position: absolute;
				width: 114px;
				height: 108px;
				bottom: -108px;
			}
			.child{
				width: 100%;
				height: 54px;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				font-weight: 400;
				// color: #FFFFFF;
			}
		}
	}
	
	.header-tag{
		display: flex;
		align-items: center;
		font-size: 14px;
		font-weight: 400;
		color: #075AD3;
		margin-top: 130px;
		margin-left: 175px;
	}
	.body-box{
		width: 100%;
		display: flex;
		align-items: flex-start;
		// justify-content: space-between;
		padding: 0 0 0 175px;
		box-sizing: border-box;
		margin-top: 50px;
		.left-box{
			width: 299px;
			height: 357px;
			background: #FAFBFF;
			padding: 24px 24px 0 24px;
			box-sizing: border-box;
			position: relative;
			margin-right: 60px;
			.tag-title{
				font-size: 20px;
				font-weight: 500;
				color: #1A1A1A;
				margin-bottom: 10px;
			}
			.new-box{
				width: 100%;
				min-height: 64px;
				// sbackground: red;
				
				font-size: 18px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				font-weight: 400;
				color: #1A1A1A;
			}
			.new-border{
				border-bottom: 1px solid #E6E6E6;
			}
			.dot{
				width: 18px;
				height: 18px;
				background: linear-gradient(320deg, rgba(103, 165, 255, 0) 0%, #77AEFF 100%);
				position: absolute;
				border-radius: 50%;
				top: 20px;
				left: 16px;
			}
		}
		.right-box{
			width: 726px;
			padding-left: 60px;
			box-sizing: border-box;
			.ri-title{
				font-size: 28px;
				font-weight: 500;
				color: #1A1A1A;
				margin-bottom: 32px;
				text-align: center;
			}
			.content{
				font-size: 16px;
				font-weight: 400;
				color: #666666;
				text-indent: 30px;
				margin-bottom: 24px;
			}
			img{
				width: 640px;
				height: 100%;
				margin-bottom: 24px;
				margin-left: 20px;
			}
			.imgs{
				width: 726px;
				height: 1000px;
			}
		}
	}
</style>
